import produce from 'immer';
import { AnyAction } from 'redux';
import {
  PUT_CANCEL_RESERVE_REQUEST,
  PUT_CANCEL_RESERVE_SUCCESS,
  PUT_CANCEL_RESERVE_FAILURE,
  PUT_CANCEL_RESERVE_INITIAL,
} from '../../actions';

export type PutCancelReserveStateType = {
  isPutCancelReserveLoading: boolean;
  isPutCancelReserveLoaded: boolean;
  errMessage: string | null;
};

const initialState: PutCancelReserveStateType = {
  isPutCancelReserveLoading: false,
  isPutCancelReserveLoaded: false,
  errMessage: null,
};

const putCancelReserveReducer = (state = initialState, action: AnyAction): PutCancelReserveStateType => {
  return produce(state, (draft) => {
    const dataState = draft;
    switch (action.type) {
      case PUT_CANCEL_RESERVE_REQUEST:
        dataState.isPutCancelReserveLoading = true;
        dataState.isPutCancelReserveLoaded = false;
        dataState.errMessage = null;
        break;
      case PUT_CANCEL_RESERVE_SUCCESS:
        dataState.isPutCancelReserveLoading = false;
        dataState.isPutCancelReserveLoaded = true;
        dataState.errMessage = null;
        break;
      case PUT_CANCEL_RESERVE_FAILURE:
        dataState.isPutCancelReserveLoading = false;
        dataState.isPutCancelReserveLoaded = false;
        dataState.errMessage = action.error.data.message;
        break;
      case PUT_CANCEL_RESERVE_INITIAL:
        dataState.isPutCancelReserveLoading = false;
        dataState.isPutCancelReserveLoaded = false;
        dataState.errMessage = null;
        break;
      default:
        break;
    }
  });
};

export default putCancelReserveReducer;
